import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router';
import apiService from '../../services/ApiService';
import { toast } from 'react-toastify';
import BannerForm from '../../components/Banner/BannerForm';

const EditBanner = () => {
  const { id } = useParams();
  const [bannerToEdit, setBannerToEdit] = useState(null);

  const getBanner = useCallback(async () => {
    const [success, error] = await apiService.get("banners/" + id)

    if (error) {
      toast.error(error.response?.data?.error?.message || "Greška pri čuvanju banera!");
      return;
    }

    setBannerToEdit(success.data);
  }, [id]);

  useEffect(() => {
    if (id) {
      getBanner();
    }
  }, [id, getBanner])

  return (
    <div className="container">
      <BannerForm bannerToEdit={bannerToEdit} />
    </div>
  );
};

export default EditBanner;